/**
 * /app/$tenantSlug/attendance/approvals — alias of the unified inbox's
 * Attendance tab (2026-10 QA #16).
 *
 * The page used to be a URL-only orphan (no nav entry — only the
 * regularization notification and the approval digest linked here), a
 * second copy of the queue the /approvals Attendance tab already shows.
 * It now redirects there, so every stored notification / email / bookmark
 * that points at /attendance/approvals still lands on the real queue.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/attendance/approvals",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/approvals",
      params: { tenantSlug: params.tenantSlug },
      search: { tab: "attendance" },
      replace: true,
    });
  },
});
